export * from './App'
export { injectReducer } from './store'
export * from './components/dropdown'
export * from './components/switch'
export * from './components/icon'
export * from './components/icons'
export * from './components/text'
export {
  SYMBOL_CONTROL_COLOR,
  SYMBOL_CONTROL_DROPDOWN,
  SYMBOL_CONTROL_SWITCH,
  SYMBOL_ICON,
} from './symbols'
export type {
  TState,
  TAction,
  TActionCreator,
  TActionWithPayload,
  TAnyAction,
} from './store/types'
export type { TPopoverPlugin, TComponentPlugin as TComponentWrapperPlugin, TComponentWrapper } from './components/plugin-provider'
export type { TComponents, TTheme, TThemeIcons, TPackageJson, TComponentControls } from './types'
